import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { ButtonComponent, IconComponent } from '@shared/components';
import { StoreDeliveryCodeEnum } from '../../enums';
import { StoreCardPresenter } from './store-card.presenter';
import { IStoreCardComponent, IStoreCardPresenter } from './interfaces';

@Component({
	selector: 'app-store-card',
	templateUrl: './store-card.component.html',
	styleUrls: ['./store-card.component.scss'],
	providers: [StoreCardPresenter],
	standalone: true,
	imports: [CommonModule, DecimalPipe, ButtonComponent, IconComponent],
})
export class StoreCardComponent
	extends IAbstractView<IStoreCardPresenter>
	implements IStoreCardComponent
{
	@Input({ required: true }) store!: StoreModel;
	@Input({ required: true }) code!: StoreDeliveryCodeEnum;
	@Input({ required: true }) isAvailable: boolean = false;
	@Input() translations: ILanguageObject = {};

	@Output() selected = new EventEmitter<{ store: StoreModel; code: StoreDeliveryCodeEnum }>();

	constructor(presenter: StoreCardPresenter) {
		super(presenter);
	}

	get scheduleText(): string {
		return this.presenter.getScheduleText(
			this.store,
			this.code,
			this.isAvailable,
			this.translations
		);
	}

	onSelect(): void {
		this.presenter.onSelectStore(this.store, this.code);
	}
}
